<section class="psy" id="equipo" [class.is-visible]="isVisible" aria-labelledby="psy-title">
  <div class="psy-inner">

    <!-- ── Encabezado de la sección ── -->
    <header class="psy-head">
      <h2 class="psy-title" id="psy-title" appRevealOnScroll>Quiénes te acompañan</h2>
      <p class="psy-lead">
        Un equipo de psicólogos clínicos que comparte la misma forma de trabajar:
        cercana, sin juicios y pensada para tu proceso.
      </p>
    </header>

    <!-- ── Carga ── -->
    <div class="psy-skeleton" *ngIf="isLoading" aria-busy="true" aria-live="polite">
      <span class="sr-only">Cargando el equipo de psicólogas…</span>
      <div class="psy-skeleton-panel"></div>
      <div class="psy-skeleton-card">
        <div class="psy-skeleton-photo"></div>
        <div class="psy-skeleton-text">
          <span class="psy-skeleton-line short"></span>
          <span class="psy-skeleton-line long"></span>
          <span class="psy-skeleton-line medium"></span>
        </div>
      </div>
    </div>

    <!-- ── Sin datos ── -->
    <p class="psy-empty" *ngIf="!isLoading && !total">
      Estamos actualizando la información del equipo. Vuelve pronto.
    </p>

    <!-- ── Carrusel ──
         Espejo de la sección de servicios (projects): allí la ficha va a la
         izquierda y el listado a la derecha; aquí el panel del equipo va a la
         izquierda y la ficha de la psicóloga escogida a la derecha. -->
    <div class="psy-stage" *ngIf="!isLoading && active"
         [class.is-single]="!hasMultiple"
         role="group"
         aria-roledescription="carrusel"
         aria-label="Equipo de psicólogas"
         tabindex="0"
         [@.disabled]="prefersReducedMotion"
         (keydown)="onKeydown($event)"
         (mouseenter)="hold()"
         (mouseleave)="release()"
         (focusin)="hold()"
         (focusout)="release()">

      <!-- Panel izquierdo: mosaico del equipo y controles -->
      <div class="psy-panel" *ngIf="hasMultiple">
        <!-- El equipo completo en orden fijo, con la actual resaltada -->
        <div class="psy-thumbs">
          <button type="button" class="psy-thumb"
                  *ngFor="let psy of psychologists; let i = index; trackBy: trackById"
                  [class.is-active]="i === currentIndex"
                  [attr.aria-current]="i === currentIndex ? 'true' : null"
                  (click)="goToPsychologist(psy)"
                  [attr.aria-label]="'Ver el perfil de ' + psy.fullName">
            <img *ngIf="psy.photo" [src]="psy.photo" [alt]="psy.fullName" loading="lazy">
            <span class="psy-thumb-initials" *ngIf="!psy.photo" aria-hidden="true">
              {{ initials(psy) }}
            </span>
            <span class="psy-thumb-overlay" aria-hidden="true">
              <span class="psy-thumb-name">{{ psy.fullName }}</span>
              <span class="psy-thumb-role" *ngIf="psy.headline">{{ psy.headline }}</span>
            </span>
          </button>
        </div>

        <!-- Controles: solo con un equipo grande; con pocas fotos basta el mosaico -->
        <nav class="psy-controls" *ngIf="showControls" aria-label="Navegación del equipo">
          <button type="button" class="psy-arrow" (click)="prev()" aria-label="Psicóloga anterior">
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
          </button>
          <span class="psy-counter">
            <span class="psy-counter-current">{{ pad(currentIndex + 1) }}</span>
            <span class="psy-counter-sep" aria-hidden="true">/</span>
            <span class="psy-counter-total">{{ pad(total) }}</span>
          </span>
          <button type="button" class="psy-arrow psy-arrow-primary" (click)="next()" aria-label="Siguiente psicóloga">
            <i class="fas fa-arrow-right" aria-hidden="true"></i>
          </button>
        </nav>
      </div>

      <!-- Ficha derecha: foto con marco desplazado y la información al lado -->
      <article class="psy-detail">
        <div class="psy-photo-frame">
          <span class="psy-photo-deco" aria-hidden="true"></span>
          <div class="psy-photo-mask" [@photoStage]="slideCounter">
            <ng-container *ngFor="let psy of activeAsList; trackBy: trackById">
              <img class="psy-photo" *ngIf="psy.photo" [src]="psy.photo" [alt]="'Fotografía de ' + psy.fullName">
              <span class="psy-photo psy-photo-initials" *ngIf="!psy.photo" aria-hidden="true">
                {{ initials(psy) }}
              </span>
            </ng-container>
          </div>
        </div>

        <div class="psy-info" [attr.aria-live]="isPlaying ? 'off' : 'polite'">
          <div class="psy-info-inner" [@textStage]="slideCounter">
            <ng-container *ngFor="let psy of activeAsList; trackBy: trackById">
              <div class="psy-card">
                <p class="psy-role" *ngIf="psy.headline">{{ psy.headline }}</p>
                <h3 class="psy-name">{{ psy.fullName }}</h3>

                <p class="psy-years" *ngIf="psy.yearsExperience">
                  <span class="psy-years-number">{{ psy.yearsExperience }}</span>
                  <span class="psy-years-label">años acompañando procesos</span>
                </p>

                <p class="psy-description" *ngIf="psy.description">{{ psy.description }}</p>

              <!--
              <div class="psy-actions">
                  <a class="psy-btn psy-btn-primary"
                     *ngIf="whatsappLink(psy) as wa"
                     [href]="wa" target="_blank" rel="noopener"
                     [attr.aria-label]="'Escribir por WhatsApp a ' + psy.fullName">
                    <i class="fab fa-whatsapp" aria-hidden="true"></i>
                  </a>
                  <a class="psy-btn psy-btn-ghost"
                     *ngIf="mailtoLink(psy) as mail"
                     [href]="mail"
                     [attr.aria-label]="'Enviar un correo a ' + psy.fullName">
                    <i class="fas fa-envelope" aria-hidden="true"></i> Correo
                  </a>
                </div>
              -->
              </div>
            </ng-container>
          </div>
        </div>
      </article>

    </div>
  </div>
</section>
